import {router} from '../router/index';
import {dictionaryColorsService} from '../_services';

export const dictionaryColors = {
  namespaced: true,
  state: {
    all: []
  },
  actions: {
    getAll ({ commit }) {
      commit('getAllRequest')
      return dictionaryColorsService.getAll()
        .then(
          dictionaryColors => commit('getAllSuccess', dictionaryColors),
          error => commit('getAllFailure', error)
        )
    },
    getById ({ commit }, id) {
      commit('getByIdRequest')
      dictionaryColorsService.getById(id).then(
        dictionaryEntry => commit('getByIdSuccess', dictionaryEntry),
        error => commit('getByIdFailure', error)
      )
    },
    create ({ dispatch, commit }, payload) {
      commit('createRequest', payload)
      dictionaryColorsService.create(payload).then(
        file => {
          commit('createSuccess', file)
          dispatch('getAll', payload)
          router.push('/dictionaries')
        },
        error => {
          commit('createFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
    },
    update ({ dispatch, commit }, payload) {
      commit('updateRequest', payload)
      dictionaryColorsService.update(payload).then(
        file => {
          commit('updateSuccess', file)
          dispatch('getAll', payload)
          router.push('/dictionaries')
        },
        error => {
          commit('updateFailure', error)
          dispatch('alert/error', error, { root: true })
        }
      )
    },
  },
  mutations: {
    getAllRequest (state) {
      state.all = []
    },
    getAllSuccess (state, dictionaryColors) {
      state.all = dictionaryColors
    },
    getAllFailure (state, error) {
      state.all = { error }
    },
    getByIdRequest (state, formData) {},
    getByIdSuccess (state, dictionaryEntry) {
      state.all = { dictionaryEntry: dictionaryEntry }
    },
    getByIdFailure (state, error) {},
    createRequest (state, formData) {},
    createSuccess (state, file) {},
    createFailure (state, error) {},
    updateRequest (state, formData) {},
    updateSuccess (state, file) {},
    updateFailure (state, error) {}
  }
}
